import React, { useEffect } from 'react';
import listRoutes from "./routes/routes";
import { Routes } from 'react-router-dom';
import createRoute from './routes/route-config';
import { GetCsrfToken } from './helper/csrf';
// import { notify } from './common/notificationService';
import { requestForToken } from './services/firebase';
import FCMListener from './components/FCMListener';
import { getCookies } from './utils/configuration';
import { DEVICE_ID_KEY, FCM_TOKEN } from './config/common';
import { useUserInfo } from './hooks/useUserInfo';
import settingService from './services/api/setting';

function App() {
  const { userInfo } = useUserInfo();

  const registerNotification = async (userId: string, fcmToken: string, deviceId: string) => {
    try {
      settingService.registerNotification({
        userId,
        deviceId,
        fcmToken,
        authToken: "",
        deviceType: 'web'
      })
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    requestForToken();
  }, []);


  useEffect(() => {
    const fcmToken = getCookies(FCM_TOKEN);
    const deviceId = getCookies(DEVICE_ID_KEY);
    if (userInfo?.id && fcmToken && deviceId) {
      registerNotification(userInfo.id, fcmToken, deviceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.id]);

  return (
    <>
      <GetCsrfToken />
      <FCMListener />
      <Routes>
        {listRoutes.map((route) => {
          return createRoute(route);
        })}
      </Routes>
    </>
  );
}

export default App;
